import React, { useEffect, useState } from 'react';
import { FaCheck, FaCheckCircle, FaChevronDown, FaChevronRight, FaEye, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { string } from 'yup';
import FadeInOnScroll from '../../../../../../components/FadeInOnScroll';

import ContainerLine from "../../../../../../components/UIComponents/ContainerLine";
import { ContainerLineUI } from "../../../../../../components/UIComponents/ContainerLine/styles";

import { ParagraphUI } from "../../../../../../components/UIComponents/Paragraph/styles";
import { ParagraphHighlightUI, TitleHighlightUI } from '../../../../../../components/UIComponents/TitleHighlight/styles';
import VideoBackground from "../../../../../../components/VideoBackground";
import { urlWebsite } from "../../../../../../config";
import { useAuth } from '../../../../../../hooks/Auth';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { useModal } from '../../../../../../hooks/Modal';
import api from '../../../../../../services/api';
import { formatReal } from '../../../../../../utils/format';
import { scrollToID } from '../../../../../../utils/scrollTo';
import LeadCapture from '../../../ButtonLeadCapture';
import RenderPageList from '../../modules/RenderList';
import RenderPageImages from "../../modules/RenderPageImages";
import { Ticket } from './styles';
function useProducts() {
  const [products, setProducts] = useState<Record<string, any>[]>([]);
  const loadProducts = async ({ project_id }) => {

    const products = await api.get(`/products-list/${project_id}`, { params: { limitItems: 10000 } });
    products?.data?.rows?.sort((a, b) => a?.price < b?.price ? -1 : a?.price > b?.price ? 1 : 0)
    setProducts(products?.data?.rows || []);

  }

  return { loadProducts, products };

}
const TicketsTemplate2 = ({ pageContent, theme }: Record<string, any>) => {
  const { hash } = pageContent;
  const { configuration } = useConfiguration();
  const { addModal } = useModal();
  const { setActiveByModal, activeByModal } = useAuth();
  const checkLeadForm = (buttonInfo: Record<string, any>) => {
    setActiveByModal(true);
    addModal({ title: '', theme: 'whiteModalMedium', content: <LeadCapture redirect={buttonInfo?.redirect} coupon={buttonInfo?.coupon} /> });
    if (buttonInfo?.id_target) {
      scrollToID(buttonInfo?.id_target)
    }

  }



  return (
    <>

      <ContainerLineUI className=' full-width column gap ' id={'tickets'} style={{ background: pageContent.background_image ? `url("${urlWebsite}/${pageContent?.background_image}")` : pageContent?.theme_data?.background ? pageContent?.theme_data?.background : '#fff', alignItems: 'flex-start', flexWrap: 'wrap', padding: '50px 30px', paddingTop: '100px' }} >

        <h2 className='whiteColor' dangerouslySetInnerHTML={{ __html: pageContent?.title?.toUpperCase() }} style={{ background: pageContent?.theme_data?.title_background, fontSize: '24px', margin: '15px auto', padding: '10px', color: pageContent?.theme_data?.title_color }} />


        <div className=' row-to-column gap' style={{ width: '100%', alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {pageContent?.data_list?.map((item) => {

            return <Ticket className=' scaleOnHover'>
              <div style={{}}>
                <h2 style={{ color: item?.color || 'rgb(2,28,60)', borderBottom: item?.border || 'none' }}  >{item?.title?.toUpperCase()}</h2>


                <p style={{ fontSize: '14px', position: 'relative', marginTop: '15px', minHeight: '16px', width: '100%', textAlign: 'center', color: '#777' }}>{item?.price_before && parseInt(item?.price_before, 10) > 0 ? <>{`de: R$  ${formatReal(item?.price_before)}`} <div style={{ width: '120px', height: '1px', background: '#ddd', position: 'absolute', top: '50%', left: '50%', transform: 'translateX(-50%)' }} /></> : ''}</p>
                <p style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>por <strong>R${item?.price}</strong> a vista</p>

                <h2 style={{ fontSize: '18px', color: '#333', marginBottom: '15px', }} dangerouslySetInnerHTML={{ __html: item?.text || '' }} />

                {activeByModal ? <Link className='full-width' to={item?.url}><button style={{ color: 'rgb(2,28,60)' }} className='highlightButtonGreenArrow'>COMPRAR</button></Link> : <button style={{ color: 'rgb(2,28,60)' }} onClick={() => checkLeadForm({ redirect: item?.url, coupon: 'SUCESSO5', id_target: 'none' })} className='highlightButtonGreenArrow'>COMPRAR</button>}
              </div>

              <div style={{ borderTop: '2px dashed #ddd', display: 'flex', paddingTop: '15px', flexDirection: 'column', gap: '10px', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                {item?.list?.map(listItem => {
                  return <div className='row gap-sm'>
                    <FaCheck /> <p style={{ fontWeight: listItem?.bold === 'yes' ? 'bold' : 400 }}>{listItem?.title}</p>
                  </div>
                })}



              </div>
            </Ticket>





          })}
        </div>
        {pageContent?.description ? <p className='whiteColor paragraph' dangerouslySetInnerHTML={{ __html: pageContent?.description?.toUpperCase() }} style={{ fontSize: '12px', textAlign: 'center', margin: '15px auto', padding: '10px', color: pageContent?.theme_data?.text_color }} /> : <></>}



      </ContainerLineUI>
    </>
  );


}

export default TicketsTemplate2;